import { useEffect } from 'react';

/**
 * Handles the /security-incident route.
 * Navigates to /security-incident served by the auth gateway (same-origin).
 */
export default function SecurityIncidentRedirect() {
  useEffect(() => {
    window.location.replace('/security-incident');
  }, []);

  return null;
}
